import { createContext, use } from 'react';

import { MultiProcessOfferDto, ProcessDto, ProcessOfferDto } from '@/api/generated';

export interface ProcessOfferContextProps {
  isLocked: boolean;
  isPredefinedTemplate: boolean;
  isPreviewMode: boolean;
  isReadOnly: boolean;
  process: ProcessDto;
  processMultiOffer: MultiProcessOfferDto;
  processOffer?: ProcessOfferDto;
}

export const ProcessOfferContextDefaultValues: ProcessOfferContextProps = {
  isLocked: false,
  isPredefinedTemplate: false,
  isPreviewMode: false,
  isReadOnly: false,
  process: {} as ProcessDto,
  processMultiOffer: {} as MultiProcessOfferDto,
  processOffer: undefined,
};

export const ProcessOfferContext = createContext<ProcessOfferContextProps>(
  ProcessOfferContextDefaultValues,
);

export const useProcessOfferContext = (): ProcessOfferContextProps => {
  return use<ProcessOfferContextProps>(ProcessOfferContext);
};
